import {
  StatusPopup,
  StatusPopupProps,
  StatusOption,
  statusTypeConfig,
} from "../status-popup/status-popup";
import { SelectTrigger, SelectValue } from "../select/select";
import { cn } from "@/lib/utils";
import { ChevronDown } from "lucide-react";
import * as SelectPrimitive from "@radix-ui/react-select";
import { useTranslation } from "react-i18next";

export interface StatusSplitButtonProps
  extends Omit<StatusPopupProps, "trigger"> {
  onSelect: (id: StatusOption["id"]) => void;
  disabled?: boolean;
}

export function StatusSplitButton({
  options,
  value,
  onValueChange,
  onSelect,
  popupOptions,
  disabled,
}: StatusSplitButtonProps) {
  const { t } = useTranslation();

  const handleSelect = () => {
    if (!value) return;
    onSelect(value);
  };
  const selected = options.find((option) => option.id === value);

  return (
    <StatusPopup
      options={options}
      value={value}
      onValueChange={onValueChange}
      popupOptions={popupOptions}
      trigger={
        <div
          className={cn(
            "flex items-center bg-white w-fit relative rounded-sm text-sm",
            selected && statusTypeConfig[selected.type].btnClass,
            selected && disabled && statusTypeConfig[selected.type].bgMutedClass
          )}
        >
          <button
            onClick={handleSelect}
            disabled={!value || disabled}
            className={cn(
              "w-full h-full p-2 text-muted-foreground",
              "border-r-white border-r-2",
              value && "text-white"
            )}
          >
            <SelectValue placeholder={t("completeOperation.select")}>
              {t("completeOperation.all", { x: selected?.label })}
            </SelectValue>
          </button>
          <SelectTrigger
            className={cn(
              "bg-inherit shadow-none p-2 text-muted-foreground outline-none",
              "[&[data-state=open]>svg]:-rotate-180",
              value && "text-white"
            )}
          >
            <SelectPrimitive.Icon asChild>
              <ChevronDown
                className={cn("transition-transform duration-200")}
              />
            </SelectPrimitive.Icon>
          </SelectTrigger>
        </div>
      }
    />
  );
}
